window.testThatErrorReportingStillWorks = ->
  setTimeout (-> throw new Error("Error reporting still works!")), 1000



// WEBPACK FOOTER //
// ./app/scripts/entry/error-test.coffee